import React, { Fragment, useEffect, useState } from 'react';
import EditWorker from './EditWorker';
import NewWorker from './NewWorker';

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import '../css/table-styles.css'

const WorkerList = ({ is_admin }) => {

    const [workers, setWorkers] = useState([]);
    const [display_workers, setDisplay_workers] = useState([]);

    const [filter_name, setFilter_name] = useState("");
    const [filter_email, setFilter_email] = useState("");
    const [filter_viewer, setFilter_viewer] = useState(false);
    const [filter_active, setFilter_active] = useState(false);

    const getWorkers = async () => {
        try {
            const response = await fetch("/workers", {
                method: "GET",
                headers: { token: localStorage.token }
            });
            const jsonDataReq = await response.json();

            jsonDataReq.rows.map(worker => {
                if (worker.worker_active == true) {
                    worker.worker_active_display = "Yes"
                } else {
                    worker.worker_active_display = "No"
                }
            })
            setWorkers(jsonDataReq.rows);
            setDisplay_workers(jsonDataReq.rows);
        } catch (err) {
            console.error("Failed: getting all workers");
            console.error(err.message);
        }
    }

    const filter = async () => {
        try {

            setDisplay_workers(workers.filter(worker => {
                var pass = true;
                if (filter_name != "") {
                    if (!worker.worker_name.toLowerCase().includes(filter_name.toLocaleLowerCase()) && !worker.worker_id.toLowerCase().includes(filter_name.toLocaleLowerCase()))
                        pass = false;
                }
                if (filter_email != "") {
                    if (!worker.worker_email.toLowerCase().includes(filter_email.toLocaleLowerCase()))
                        pass = false;
                }
                if (filter_viewer) {
                    if (worker.is_admin == 0) {
                        pass = false;
                    }
                }
                if (filter_active) {
                    if (!worker.worker_active) {
                        pass = false
                    }
                }
                return pass;
            }))

        } catch (err) {
            console.error("Failed: filtering workers");
            console.error(err.message);
        }
    }

    useEffect(() => {
        getWorkers();
    }, [])

    useEffect(() => {
        filter();
    }, [filter_name, filter_email, filter_active, filter_viewer])

    return (
        <Fragment>
            <div className="container">
                <h1 className="mt-2 d-inline-block">Worker List </h1>
                {is_admin==2 && <NewWorker refresh_workers={getWorkers}/>}
                <h5 className="ml-2">Filters:</h5>
                <input className="form-control m-1" type="text" placeholder="Name" value={filter_name} onChange={e => setFilter_name(e.target.value)} />
                <input className="form-control m-1" type="text" placeholder="Email" value={filter_email} onChange={e => setFilter_email(e.target.value)} />


                <input placeholder="Viewer" type="checkbox" className="form-check-input ml-2 mt-2" id="viewer_filter_check" value={filter_viewer} onChange={e => setFilter_viewer(e.target.checked)} />
                <label className="form-check-label ml-5 mt-1" htmlFor="viewer_filter_check">
                    Viewer
                </label>

                <input placeholder="Active" type="checkbox" className="form-check-input ml-2 mt-2" id="active_filter_check" value={filter_active} onChange={e => setFilter_active(e.target.checked)} />
                <label className="form-check-label ml-5 mt-1" htmlFor="active_filter_check">
                    Active
                </label>
                <Table className="table text-center">
                    <Thead>
                        <Tr>
                            <Th>Internal Worker ID</Th>
                            <Th>Name</Th>
                            <Th>Email</Th>
                            <Th>Active?</Th>
                            <Th>Admin Level</Th>
                            {is_admin === 2 && <Th>Edit</Th>}
                            {/* {is_admin === 2 && <Th>Make Inactive</Th>} */}

                        </Tr>
                    </Thead>
                    <Tbody>
                        {/* <Tr>
                        <Td>John</Td>
                        <Td>Doe</Td>
                        <Td>john@example.com</Td>
                    </Tr> */}
                        {display_workers.map(worker => (
                            <Tr key={worker.worker_id}>
                                <Td>{worker.worker_id}</Td>
                                <Td>{worker.worker_name}</Td>
                                <Td>{worker.worker_email}</Td>
                                <Td>{worker.worker_active_display}</Td>
                                <Td>{worker.is_admin}</Td>
                                {is_admin === 2 && <Td><EditWorker this_worker={worker} refresh_workers={getWorkers} /></Td>}
                                {/* {is_admin === 2 && <Td><button className="btn btn-danger">Make Inactive</button></Td>} */}
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </div >
        </Fragment>
    );
}

export default WorkerList;

// const body = { temp_worker_id, client, start, end, expenses, m_travelled, description };
